import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["triggerInput", "accessGroupWrapper"]

  connect() {
    this.toggleAccessGroupSelect()
  }

  triggerChanged() {
    this.toggleAccessGroupSelect()
  }

  toggleAccessGroupSelect() {
    if (!this.hasTriggerInputTarget) return

    if (this.triggerInputTarget.value === "none") {
      this.accessGroupWrapperTarget.classList.add("hidden")
    } else {
      this.accessGroupWrapperTarget.classList.remove("hidden")
    }
  }
}
